<template>
  <div class="header">
    <!-- {{poiInfo.name}} -->

    <!-- 頂部通欄 -->
    <div class="top-wrapper">
      <div class="back-wrapper">
        <span class="icon-arrow_lift"></span>
      </div>
      <form class="search-wrapper">
        <span class="search-icon"></span>
        <input class="search-bar" type="text" placeholder="請輸入店內商品">
      </form>
      <div class="more-wrapper">
        <a class="spelling-bt" href="#">拚單</a>
        <div class="more-bt">
          <i class="s-radius"></i>
          <i class="s-radius"></i>
          <i class="s-radius"></i>
        </div>
      </div>
    </div>

    <!-- 主題內容 -->
    <div class="content-wrapper">
      <div class="icon" :style="icon_img">
        <!-- <img :src="poiInfo.pic_url" /> -->
      </div>
      <div class="name">
        <h3>{{ poiInfo.name }}</h3>
      </div>
      <div class="collect">
        <img src="../../../resource/img/star.png" />
        <span>收藏</span>
      </div>
    </div>

    <!-- 公告內容 -->
    <div class="bulletin-wrapper">
      <img class="icon" v-if="poiInfo.discounts2" :src="poiInfo.discounts2[0].icon_url" />
      <span class="text" v-if="poiInfo.discounts2">{{poiInfo.discounts2[0].info}}</span>
      <div class="detail" v-if="poiInfo.discounts2"  @click="showBulletin">
        {{ poiInfo.discounts2.length }}個活動
        <span class="icon-keyboard_arrow_right"></span>
      </div>
    </div>

    <!-- 背景圖片 -->
		<div class="bg-wrapper" :style="content_bg">
			<!-- <img :src="poiInfo.head_pic_url" /> -->
		</div>

    <!-- 公告詳情 -->
    <transition name="detail">
    <div class="bulletin-detail" v-show="isShow">
      <div class="detail-wrapper">
        <div class="main-wrapper" :style="detail_bg">
          <div class="icon" :style="icon_img"></div>
          <h3 class="name">{{ poiInfo.name }}</h3>

          <!-- 評價(稍後) -->
          <div class="score">
            <Star :score='poiInfo.wm_poi_score'></Star>
            <span>{{poiInfo.wm_poi_score}}</span>
          </div>

          <p class="tip">
            {{ poiInfo.min_price_tip }} <i>|</i>
            {{ poiInfo.shipping_fee_tip }} <i>|</i>
            {{ poiInfo.delivery_time_tip }}
          </p>
          <p class="time">
            配送時間:
            {{ poiInfo.shipping_time }}
          </p>
          <div class="discounts" v-if="poiInfo.discounts2">
            <p>
              <img :src="poiInfo.discounts2[0].icon_url" />
              <span>{{poiInfo.discounts2[0].info}}</span>
            </p>
          </div>
        </div>
        <div class="close-wrapper">
          <span class="icon-close" @click="closeBulletin"></span>
        </div>
      </div>
    </div>
    </transition>

  </div>
</template>
<script>
//導入星等評分
import Star from '../Star/Star'

  // console.log(props);
  export default {
    	data() {
			return {
        isShow: false,   //公告詳情默認為不顯示
        // content_bg:this.poiInfo.head_pic_url ,
			}
		},
    components: {Star},
    props: {    //組件傳值
      poiInfo:{
        type: Object,
        default: {}
      }
    },
    computed:{    //計算屬性
			content_bg() {
				return "background-image: url(" + this.poiInfo.head_pic_url + ");"
			},
      icon_img() {
        return "background-image: url(" + this.poiInfo.pic_url + ");"
      },
      detail_bg() {
        return "background-image: url(" + this.poiInfo.poi_back_pic_url + ");"
      },
    },
    methods: {
      showBulletin(){
        this.isShow= true
      },
      closeBulletin(){
        this.isShow= false
      }
    }
  }
</script>
<style>
    /* 導入字體圖標 */
    @import url("../../common/styles/icon.css");
    /* 導入CSS樣式 */
    @import url("./Header.css");
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue